import { ReactNode, useContext, useEffect, useState } from "react";
import { BigHeading, DatePickerContainer, FlexContainer, FormContainer, GreenButton, Label, SearchingBoxContainer, SearchingListContainer } from "../assets/style";
import MainContent from "./MainContent";
import ReactLoading from "react-loading";
import { Box, FormControl, MenuItem, Pagination, PaginationItem, Select, TablePaginationProps, TextField, styled } from "@mui/material";
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React from "react";
import { useNavigate } from "react-router-dom";
import { GlobalStateContext } from "../store/GlobalState";
import { useGetErrorExcelMutation, useLazyGetErrorLogQuery } from "../features/errorLog/errorLogSlice";
import { ErrorLogRow } from "../components/models/ErrorLogRecordModel";
import { DataGrid, GridCellParams, GridColDef, GridPagination, GridRowId, GridRowsProp, GridToolbarQuickFilter, GridValidRowModel, gridPageCountSelector, useGridApiContext, useGridSelector } from "@mui/x-data-grid";
import { Result_First_Page_Icon, Result_Last_Page_Icon, Result_Next_Page_Icon, Result_Previous_Page_Icon } from "../assets/imgs";

const ExportToExcelAndCustomPaginationContainer = styled(Box)`
  display: flex;  
  width: 100%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 600px) {
    display: block;
  }
`;

function CustomGridToolbarQuickFilter() {
    return <GridToolbarQuickFilter sx={{
        paddingBottom: '0px',
        borderBottom: '2px solid #E2FFA5',
        '& .MuiInputBase-input': {
            fontSize: 'calc(12px + 0.3vw)',
        }
    }} />
}

function ActionsComponent({ page, onPageChange, className, }: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <Pagination
            showFirstButton
            showLastButton
            renderItem={(item) => (

                <PaginationItem
                    sx={{
                        fontSize: 'calc(12px + 0.6vw)'
                    }}
                    slots={{ previous: () => <img src={Result_Previous_Page_Icon} />, next: () => <img src={Result_Next_Page_Icon} />, first: () => <img src={Result_First_Page_Icon} />, last: () => <img src={Result_Last_Page_Icon} /> }}
                    {...item}
                />
            )}
            variant="outlined"
            shape="rounded"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event as any, newPage - 1);
            }}
        />
    );
}



const columns: GridColDef[] = [
    { field: 'rfid', headerName: 'QR/RFID', width: 200, minWidth: 50, headerClassName: 'header' },
    { field: 'errorLog', headerName: 'Error Log', width: 200, minWidth: 50, headerClassName: 'header' },
    { field: 'errorDate', headerName: 'Date / Time', width: 240, minWidth: 50, headerClassName: 'header' },
    { field: 'robotNumber', headerName: 'Robot Code', width: 180, minWidth: 50, headerClassName: 'header' },
    // { field: 'errorLevel', headerName: 'Error Code', width: 180, minWidth: 50, headerClassName: 'header' },
    { field: 'acknowledgeBy', headerName: 'Acknowledge by', width: 200, minWidth: 50, headerClassName: 'header' },
    { field: 'acknowledgeOn', headerName: 'Acknowledge On', width: 200, minWidth: 50, headerClassName: 'header' },
];

const ErrorLog = () => {
    const [getErrorLog, getErrorLogResult] = useLazyGetErrorLogQuery();
    const [getErrorExcel] = useGetErrorExcelMutation();
    const [castForm, setCastForm] = React.useState<Dayjs | string | null>(null);
    const [castTo, setCastTo] = React.useState<Dayjs | string | null>(null);
    const [testForm, setTestForm] = React.useState<Dayjs | string | null>((dayjs(new Date()).subtract(7, 'day'))); // default 1 week 
    const [testTo, setTestTo] = React.useState<Dayjs | string | null>(null);
    const [code, setCode] = useState('')
    const [robotCode, setRobotCode] = React.useState('0');
    const [errorLevel, setErrorLevel] = React.useState('0');
    const [isLoadingList, setIsLoading] = useState(false);
    const globalState = useContext(GlobalStateContext);
    const navigate = useNavigate();
    const [tableContent, setTableContent] = useState<ReactNode>(null);
    const [selectedRows, setSelectedRows] = useState<GridRowId[]>([]);
    const [errorLogRows, seterrorLogRows] = useState<ErrorLogRow[]>([]);
    const [listForExcel, setListForExcel] = useState<ErrorLogRow[]>([]);

    const downloadExcelFile = async () => {
        try {
            await getErrorExcel(listForExcel).then((res) => {
                // console.log((res as any).data)
                const link = document.createElement('a');
                link.href = (res as any).data;
                link.download = 'ErrorLogReport.xlsx';
                link.click();
                // URL.revokeObjectURL(url); // Clean up the temporary URL
            });


        } catch (error) {
            // Handle any errors
        }
    };

    const CustomPagination =
        (props: any) => {
            return (
                <ExportToExcelAndCustomPaginationContainer>
                    <GreenButton variant='contained' sx={{ height: '30px' }} onClick={downloadExcelFile}>Export Excel</GreenButton>
                    <GridPagination ActionsComponent={ActionsComponent} {...props} />
                </ExportToExcelAndCustomPaginationContainer>
            );
        }

    useEffect(() => {
        // Check if the selectionModel has changed
        // console.log('Selection model changed:', selectedRows);
        const newDataList = selectedRows.map((index) => {
            const selectedId = index as number;
            const foundItem = errorLogRows.find((item: any) => item.id === selectedId);
            return foundItem as ErrorLogRow;
        });
        setListForExcel(newDataList);
    }, [selectedRows]);

    useEffect(() => {
        handleTableData()
    }, []);

    const handleTableData = async () => {
        setIsLoading(true)
        try {
            if (globalState.token) {
                getErrorLog(
                    {
                        DateCastFrom: castForm?.toString(),
                        DateCastTo: castTo?.toString(),
                        DateTestFrom: testForm?.toString(),
                        DateTestTo: testTo?.toString(),
                        RFID: code,
                        RobotNumber: robotCode,
                        ErrorLevel: errorLevel,
                    }
                ).then(
                    () => { setIsLoading(false) }
                )
            }
        } catch (error) {
            // setIsLoading(false);
            alert('An error occurred. Please refresh (F5) or login again.');
            localStorage.setItem('token', '');
            globalState.setToken('');
            navigate("/");
        } finally {
            // setIsLoading(false); // Set isLoading to false when loading or updating is completed or when an error occurs
        }
    }

    useEffect(() => {
        if (getErrorLogResult.isSuccess) {
            const responseData = getErrorLogResult.data;
            const mutableRows = (responseData as unknown as any[]).map((record: any, index: number) => {
                return {
                    id: record.id,
                    rfid: record.rfid || '-',
                    errorLog: record.errorLog || '-',
                    errorDate: record.errorDate || '-',
                    acknowledgeBy: record.acknowledgeBy || '-',
                    acknowledgeOn: record.acknowledgeOn || '-',
                    robotNumber: record.robotNumber || '-',
                    errorLevel: record.errorLevel || '-'
                };
            });
            seterrorLogRows(mutableRows)
            setTableContent(
                <>
                    <DataGrid
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        columnHeaderHeight={56}
                        getRowHeight={() => 'auto'}
                        slots={{
                            pagination: CustomPagination,
                            toolbar: CustomGridToolbarQuickFilter
                        }}
                        autoHeight
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                        pageSizeOptions={[10]}
                        disableColumnMenu
                        checkboxSelection
                        onRowSelectionModelChange={(row) => setSelectedRows(row)}
                        rows={mutableRows}
                        columns={columns}
                        sx={{
                            '& .MuiDataGrid-selectedRowCount': { display: 'none' },
                            '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' },
                            'fontSize': 'calc(12px + 0.3vw)',
                            'padding': '0 15px 15px 22px',
                            'backgroundColor': 'white',
                            '& .header': {
                                fontWeight: '900',
                                paddingTop: '14px',
                                paddingBottom: '14px',
                                paddingLeft: '7px',
                                borderWidth: '4px',
                                borderStyle: 'solid',
                                borderImage: 'linear-gradient(to bottom, rgba(226, 255, 165, 0.6), rgba(67, 182, 86, 0.6)) 1'
                            },
                            "& .even": {
                                backgroundColor: "#E2E2E2"
                            }
                        }}
                    />
                </>
            )
        }
    }, [getErrorLogResult, getErrorLog, listForExcel])

    return (
        <>
            <MainContent type={"error"} >
                <BigHeading >Error Log</BigHeading>
                <SearchingBoxContainer >
                    <br></br>
                    <div >
                        <FlexContainer>
                            <Label>Date Cast:</Label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <FlexContainer>
                                    <DatePickerContainer>
                                        <DatePicker
                                            label="Form"
                                            value={castForm}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setCastForm(newValue ? newValue : null)}
                                        />
                                    </DatePickerContainer>

                                    <DatePickerContainer>
                                        <DatePicker
                                            label="To"
                                            value={castTo}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setCastTo(newValue ? newValue : null)}
                                        />
                                    </DatePickerContainer>
                                </FlexContainer>

                            </LocalizationProvider>

                            <Label>RFID/QR Code:</Label>
                            <TextField
                                id="code"
                                label="RFID / QR Code"
                                variant="outlined"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                style={{ marginLeft: '20px' }}
                            />

                            <Label>Robot Code: </Label>
                            <DatePickerContainer>
                                <FormControl style={{ marginLeft: '20px' }}>
                                    <Select
                                        id="robot"
                                        value={robotCode}
                                        onChange={(e) => setRobotCode(e.target.value)}
                                        style={{ height: 35, backgroundColor: '#fff' }}
                                    >
                                        <MenuItem value={"0"}>All</MenuItem>
                                        <MenuItem value={"1"}>Robot 1</MenuItem>
                                        <MenuItem value={"2"}>Robot 2</MenuItem>
                                        <MenuItem value={"3"}>Robot 3</MenuItem>
                                        <MenuItem value={"4"}>Robot 4</MenuItem>
                                        <MenuItem value={"5"}>Robot 5</MenuItem>
                                        {/* <MenuItem value={"6"}>Robot 6</MenuItem> */}
                                    </Select>
                                </FormControl></DatePickerContainer>

                            <Label>Error Level: </Label>
                            <DatePickerContainer>
                                <FormControl style={{ marginLeft: '20px' }}>
                                    <Select
                                        id="error"
                                        value={errorLevel}
                                        onChange={(e) => setErrorLevel(e.target.value)}
                                        style={{ height: 35, backgroundColor: '#fff' }}
                                    >
                                        <MenuItem value={"0"}>All</MenuItem>
                                        <MenuItem value={"1"}>Level 1</MenuItem>
                                        <MenuItem value={"2"}>Level 2</MenuItem>
                                        <MenuItem value={"3"}>Level 3</MenuItem>
                                    </Select>
                                </FormControl>
                            </DatePickerContainer>
                        </FlexContainer>
                    </div>

                    <br></br>
                    <div >
                        <FlexContainer>
                            <Label >Date Test:</Label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <FlexContainer>
                                    <DatePickerContainer>
                                        <DatePicker
                                            label="Form"
                                            value={testForm}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setTestForm(newValue ? newValue : null)}
                                        />
                                    </DatePickerContainer>

                                    <DatePickerContainer>
                                        <DatePicker
                                            label="To"
                                            value={testTo}
                                            sx={{ marginLeft: '20px' }}
                                            onChange={(newValue) => setTestTo(newValue ? newValue : null)}
                                        />
                                    </DatePickerContainer>
                                </FlexContainer>
                            </LocalizationProvider>

                            <FlexContainer>

                                <GreenButton
                                    style={{ marginLeft: '23px', height: '30px' }}
                                    variant="contained"
                                    type="submit"
                                    // onClick={handleTableData}
                                    onClick={() => {
                                        // getErrorLog(
                                        //     {
                                        //         DateCastFrom: castForm as string | undefined,
                                        //         DateCastTo: castTo as string | undefined,
                                        //         DateTestFrom: testForm as string | undefined,
                                        //         DateTestTo: testTo as string | undefined,
                                        //         RFID: code,
                                        //         RobotNumber: robotCode,
                                        //         ErrorLevel: errorLevel,
                                        //     }
                                        // )
                                        handleTableData()
                                    }}
                                >
                                    Search
                                </GreenButton>
                            </FlexContainer>
                        </FlexContainer>
                    </div >
                    <br></br>
                </SearchingBoxContainer>

                <SearchingListContainer>
                    {/* {tableContent} */}
                    {isLoadingList && (
                        <ReactLoading className="justify-items-center" type={"bubbles"} color={'#9e9e9e'} height={'20%'} width={'20%'} />
                    )}
                    {!isLoadingList &&
                        tableContent}
                </SearchingListContainer>

            </MainContent >

        </>
    )
};
export default ErrorLog;